import { Chat } from '../../chat/Chat';
import { LoginMethod } from '../../item/login-request';
export interface UserObject {
    name?: string,
    lastname?: string,
    role?: string,
    id?: number,
    phone?: string,
    credit?: number,
    userID: string,
    googleID?: string,
    facebookID?: string,
    displayName?: string,
    familyName?: string,
    givenName?: string,
    imageUrl?: string,
    fbStatus?: string,
    fbAuthResponse?: Object,
    authResponse?: string,
    email?: string,
    hashKey?: string,
    mainAccessToken?: string,
    password?: string,
    loginMethode?: string,
    joined?: boolean,
    points?: number,
    checked?: any;
    joinedChats?: Array<Chat>;
    tempemail?: string;
    temppass?: any;
    frgpass?: boolean;
    registrationType?: string;
}
export class User {
    getUserObject(): UserObject {
        return this.getSimpleModel() as unknown as UserObject
    }
    public name?: string;
    public lastname?: string;
    public role?: string;
    private id?: number;
    public phone?: string;
    public credit?: number;
    public userID: string;
    public googleID?: string;
    public facebookID?: string;
    public displayName?: string;
    public familyName?: string;
    public givenName?: string;
    public imageUrl?: string = "";
    public fbStatus?: string;
    public fbAuthResponse?: Object;
    public email: string;
    public hashKey?: string;
    private mainAccessToken?: string;
    public password: string;
    public loginMethode?: LoginMethod;
    public joined?: boolean = false;
    public checked = false;
    public points?: number = 100;
    public joinedChats?: Array<Chat> = [];;
    public tempemail?: string;
    public temppass?: any;
    public frgpass?: boolean = true;
    public registrationType?: string;
    constructor(userObject: UserObject) {
        this.initUser(userObject);
    }

    initUser(userObject: UserObject) {
        this.name = userObject.name;
        this.lastname = userObject.lastname;
        this.role = userObject.role;
        this.phone = userObject.phone;
        this.credit = 100;

        this.mainAccessToken = userObject.mainAccessToken;
        this.userID = userObject.userID;
        this.googleID = userObject.googleID;

        this.displayName = userObject.displayName;
        this.familyName = userObject.familyName;
        this.givenName = userObject.givenName;
        this.imageUrl = userObject.imageUrl;

        this.email = userObject.email ? userObject.email.toLowerCase() : '';

        this.phone = userObject.phone;
        this.registrationType = userObject.registrationType;

        if (userObject.points)
            this.points = userObject.points;
    }
    setMainAccessToken(accessToken: string) {
        this.mainAccessToken = accessToken;
    }
    isFacebookUser() {
        return this.fbStatus == "connected";
    }
    hasAccessToken() {
        return this.mainAccessToken && this.mainAccessToken.length > 0;
    }
    hasImage() {
        return this.imageUrl && true;
    }
    getFirstChars() {
        if (this.name && this.lastname)
            return this.name.slice(0, 1) + this.lastname.slice(0, 1);
        else if (this.email)
            return this.email.slice(0, 1);
        else
            return ":)";
    }

    getMainAccessToken() {
        return this.mainAccessToken;
    }
    getSimpleModel() {
        let userData = Object.assign({}, this);
        return userData;
    }
    setPassword(password: string) {
        this.password = password;
    }
    setLoginMethode(loginMethode: LoginMethod) {
        this.loginMethode = loginMethode;
    }

}